
























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import NavDrawerContent from '@/components/gambling/NavDrawerContent.vue'
import { mapState } from 'vuex'

@Component({
  components: {
    NavDrawerContent
  },
  computed: {
    ...mapState({
      customCss: ({ cashierContext }: any): string => cashierContext.customCss,
      autoProcessProvider: ({ cashierContext }: any): string => cashierContext.autoProcessProvider
    })
  }
})

export default class HomePageOne extends Vue {
  @Mutation('setAccountType') setAccountType: any
  @Mutation('setLogInModal') setLogInModalCommit: any
  @Mutation('setDrawerMiniVariant') setDrawerMiniVariant: any

  @Prop({ type: Boolean, required: false }) isAuthenticated!: boolean
  @Prop({ type: Function, required: false }) makeDeposit!: void
  @Prop({ type: String, required: false }) currencyCode!: string
  @Prop({ type: String, required: false }) fullName!: string

  $smallScreen!: any
  $routeChange!: any
  customCss!: string
  autoProcessProvider!: string
  $cashierConfigs!: any

  openLogin () {
    this.setLogInModalCommit(true)
  }

  depositCampaign () {
    this.setDrawerMiniVariant(false)
    this.$cashierConfigs('quickDeposit')
  }

  toDeposit () {
    this.setAccountType('banking')
    const setConfig = (type: string) => this.$cashierConfigs(type)
    this.$cashierConfigs('dynamicCashierType')
    this.$routeChange('/gambling/account')
  }
}
